<template>
  <v-container fluid class="password-container pa-0">
    <!-- Modern Header -->
    <div v-if="showHeader" class="header-section mb-4">
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-lock-reset</v-icon>
        </div>
        <div class="flex-grow-1">
          <h1 class="page-title mb-1">Change Password</h1>
          <p class="page-subtitle mb-0">
            Update your account password for security
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            class="mr-2 white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-lock</v-icon>
            Secure
          </v-chip>
          <v-chip
            class="white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-shield-check</v-icon>
            Protected
          </v-chip>
        </div>
      </div>

      <!-- Feature Pills -->
      <v-row class="feature-pills ma-0">
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-lock-reset</v-icon>
            <span>Password Reset</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-shield-lock</v-icon
            >
            <span>Security</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-key-variant</v-icon
            >
            <span>Authentication</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-account-check</v-icon
            >
            <span>Account Safety</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0 px-3">
      <v-col cols="12" md="6" lg="5" xl="4" class="mx-auto">
        <v-card class="modern-card customBorderRadius" elevation="0">
          <div class="card-header-green"></div>
          <v-card-title class="pb-2 pt-6 justify-center">
            <div class="text-center">
              <div class="icon-circle mb-3">
                <v-icon color="primary" size="48">mdi-lock-outline</v-icon>
              </div>
              <h3 class="text-h5 font-weight-medium mb-2">
                Change Your Password
              </h3>
              <p class="text-caption text--secondary mb-0">
                Enter your current password and choose a new one
              </p>
            </div>
          </v-card-title>

          <v-card-text class="pa-6">
            <v-form ref="form">
              <label class="input-label">Current Password</label>
              <v-text-field
                v-model="reset.old"
                type="password"
                outlined
                dense
                placeholder="Enter your current password"
                class="mb-4 customBorderRadius"
                hide-details="auto"
                prepend-inner-icon="mdi-lock"
                clearable
              />

              <label class="input-label">New Password</label>
              <v-text-field
                v-model="reset.new"
                type="password"
                outlined
                dense
                placeholder="Enter your new password"
                class="mb-4 customBorderRadius"
                hide-details="auto"
                prepend-inner-icon="mdi-lock-plus"
                clearable
              />

              <label class="input-label">Confirm New Password</label>
              <v-text-field
                v-model="reset.confirmNew"
                type="password"
                outlined
                dense
                placeholder="Re-enter your new password"
                class="mb-4 customBorderRadius"
                hide-details="auto"
                prepend-inner-icon="mdi-lock-check"
                clearable
              />

              <div class="text-center mt-6">
                <v-btn
                  color="primary"
                  depressed
                  large
                  block
                  style="border-radius: 8px;"
                  @click="update('changePassword')"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Update Password
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primarygrad white--text" dark>
        <v-card-text style="padding: 18px 25px">
          <h3 style="margin-bottom: 5px; font-weight: 400; font-size: 16px">
            Please Wait...
          </h3>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showHeader: false,
      loader: false,
      reset: {
        old: "",
        new: "",
        confirmNew: "",
      },
    };
  },
  computed: {
    ...mapState(["ENDPOINT"]),
  },
  created() {
    this.showHeader =
      localStorage.getItem("changePasswordHeaderDismissed") !== "true";
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("changePasswordHeaderDismissed", "true");
    },
    // reset data after operation
    close() {
      const self = this;

      self.reset = {
        old: "",
        new: "",
        confirmNew: "",
      };

      // close loader
      self.loader = false;
    },

    async update(what) {
      const self = this;
      // initiate loader
      self.loader = true;
      var payload = {};

      switch (what) {
        case "changePassword":
          if (self.reset.new != self.reset.confirmNew) {
            self.loader = false;
            return self.$swal({
              type: "warning",
              text: "Passwords did'nt match",
            });
          }

          payload.userid = self.$store.getters.user.id;
          payload.username = self.$store.getters.user.username;
          payload.oldPassword = self.reset.old;
          payload.newPassword = self.reset.new;

          self.$http
            .put(`${this.ENDPOINT}/accounts/updatePassword`, payload)
            .then((response) => {
              self
                .$swal({
                  type: "success",
                  text: "Successful",
                })
                .then(function(isConfirm) {
                  self.logout();
                });
            })
            .catch((err) => {
              self.$swal({ type: "error", text: err.body.error.message });
            });
          break;
      }

      self.close();
    },

    logout() {
      this.$store.dispatch("setUser", false);
      window.localStorage.clear();
      window.location.href = "/";
    },
  },
};
</script>
<style scoped>
.password-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .password-container {
  background-color: #121212 !important;
}

.header-section {
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px;
  padding: 32px;
  color: white;
  box-shadow: 0 4px 20px rgba(55, 207, 55, 0.3);
}

.header-icon-wrapper {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.feature-pills {
  margin-top: 24px;
}

.feature-pill {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.feature-pill:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.modern-card {
  background: white;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.customBorderRadius {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.card-header-green {
  height: 4px;
  background: linear-gradient(90deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px 12px 0 0;
}

.icon-circle {
  width: 80px;
  height: 80px;
  background: rgba(55, 207, 55, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.input-label {
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
}

@media (max-width: 960px) {
  .header-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .page-title {
    font-size: 28px;
  }
}
</style>
